export default "__VITE_ASSET__4F2oLPPh__"